module.exports = __webpack_public_path__ + "static/media/usaid_logo.8ebb326b.png";